import Modal from 'lib/Modal';
import warningSvg from 'assets/icons/warning.svg';
import { RouteFrameCode } from 'components/common/types/Deal.types';
import Button, { Color } from 'lib/Button';

interface FailedFramesModalProps {
  isOpen: boolean;
  onClose: () => void;
  rejectedFrames: RouteFrameCode[];
}

const FailedFramesModal = ({ isOpen, onClose, rejectedFrames }: FailedFramesModalProps): React.ReactElement => {
  const acceptButton = <Button label="Accept" onClick={onClose} color={Color.PRIMARY} />;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      icon={warningSvg}
      title="Frame IDs not added"
      dataTestId="failed-frames-modal"
      actionButtons={acceptButton}
    >
      <div className="flex flex-col gap-1 w-125 h-96 overflow-y-scroll">
        {rejectedFrames.map((frame) => (
          <div key={frame.code} className="flex gap-1">
            <span className="text-neutral-600">Frame ID:</span>
            <span>{frame.code}</span>
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default FailedFramesModal;
